const live = {
    IS_DEV: false,
    TITLE: "School Accounts Planet Pop Phase6",
};

export default live;

